import { useCallback, useEffect, useState } from 'react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { useSelector } from 'react-redux';

import { INFRASTRUCTURE_MF_NAME } from '../../constants/microfrontends';
import { getNewbuildingId } from '../../selectors/newbuilding';
import { getInfrastructureMicrofrontendManifest } from '../../services/infrastructureMicrofrontend';
import { useApplicationContext } from '../../utils/withApplicationContext';

/**
 * @param enabled - манифест подготавливается только после включения,
 * чтобы не загружать микрофронт для пользователей, не доскроливших до карты
 */
export function useInfrastructureMicrofrontend(enabled: boolean) {
  const newbuildingId = useSelector(getNewbuildingId);
  const ctx = useApplicationContext();
  const [manifest, setManifest] = useState<IMicrofrontendManifest | null>(null);
  const [status, setStatus] = useState<'loading' | 'error' | 'success'>('loading');

  const fetchManifest = useCallback(async () => {
    setStatus('loading');
    const mfManifest = await getInfrastructureMicrofrontendManifest(ctx, newbuildingId);

    if (mfManifest !== null) {
      ctx.microfrontendsRegistry.register(mfManifest);
      setStatus('success');
      setManifest(mfManifest);
    } else {
      setStatus('error');
    }
  }, [ctx, newbuildingId]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const mf = ctx.config.get<IMicrofrontendManifest>(`microfrontendManifests.${INFRASTRUCTURE_MF_NAME}`);

    if (!mf) {
      fetchManifest();
    } else {
      setManifest(mf);
      setStatus('success');
    }
  }, [ctx.config, fetchManifest, enabled]);

  return { manifest, fetchManifest, status };
}
